<template>
  <b-modal :hide-header="true" :hide-footer="true" :body-class="['p-0']" class="export-activity-success-modal" scrollable :no-close-on-backdrop="true" style="width: 539px" v-model="confirmEmailModal">
    <div v-if="phoneVerified" class="phone-verified">
      <div class="phone-verified-check">
        <img src="@/assets/ICN - green check big.png" alt="green check" />
      </div>
      <div class="schedule-heading">
        <p class="p-0" v-translate:label_verification_confirmation="lang">
          Your phone was successfully verified!
        </p>
      </div>
      <div class="telehealth mt-auto">
        <div class="text-center vs-document-btn pt-48 mt-auto">
          <button class="btn btn-submit" :disabled="cantContinue" v-translate:done="lang" @click="continueToPweb">
            Continue
          </button>
        </div>
      </div>
    </div>
    <div v-else-if="showVerifyOtpModal">
      <AuthOtp class="verifyRegistrationPhone" :lang="lang" :phoneFlag="'phone'" :eventType="'verifyRegistrationPhoneNo'" :email="participantRegistration.email" :title="widget.translate('pweb_title_verify_identity', 'Verify Identity')" @onSubmit="verifyOtp" @onResendVerificationCode="onResendVerificationCode" />
    </div>
    <div v-else class="partipant-registration-modal__container pl-15 pr-15">
      <div class="confirmEmailTitle pt-48 cursor-contextMenu">
        {{ verifyIdentityPageTitle }}
      </div>
      <div class="verification text-center">
        <p class="mb-0 email-msg">{{ verifyTextSendToText }}</p>
        <label v-if="isPhoneVerification" class="email-id m-0">{{ participantIdentity | national | trim0 }}</label>
        <label v-else class="email-id m-0">{{ participantRegistration.email || participantIdentity }}</label>
        <p class="paricipant-reg-name primary-text" style="color: var(--primary) !important">
          {{ participantFullName }}
        </p>
        <p class="email-text mb-10 pl-26 pr-26 pt-0 mt-48">
          {{ resendConfirmCodeDescription }}
        </p>
        <p class="email-text1 cursor-pointer" @click="onResendVerification">
          {{ resendVerificationBtnText }}
        </p>
        <p class="email-text1 cursor-pointer" v-if="portal.isOpenEnrollmentStudy()" @click="$emit('onChangeEmail', true)" v-translate:label_wrong_email="lang">
          Wrong email address?
        </p>
        <p class="pt-32 cursor-contextMenu m-0" v-if="!isPhoneVerification" v-translate:pw_email_verify="lang">
          Once verified, click below.
        </p>
        <p class="pt-32 cursor-contextMenu m-0" v-else v-translate:pw_email_verify="lang">
          Once received, click below.
        </p>
      </div>
      <div class="continue-btn-div pt-5">
        <button class="btn btn-submit primary-bg mb-48 d-block" @click="checkIfVerified()" data-dismiss="modal" v-translate:label_continue="lang" style="background-color: var(--primary) !important" :disabled="showLoader">Continue</button>
      </div>
      <div v-if="showLoader">
        <loader v-if="showLoader"></loader>
        <vue-progress-bar class="progress_bar_header"></vue-progress-bar>
      </div>
    </div>
  </b-modal>
</template>
<script>
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import { ParticipantPortal, Participant, Widget } from "@/components/services/participant-service";
import { v4 as uuidv4 } from "uuid";
import AuthOtp from "@/components/participant-portal/auth/otp";
import loader from "@/components/common/loader";
export default {
  name: "VerifyUserIdentity",
  props: ["showLoaderProp", "value", "lang", "date", "participantId", "phoneObject"],
  components: { AuthOtp, loader },
  data() {
    return {
      portal: new ParticipantPortal(),
      widget: new Widget(),
      showLoader: this.showLoaderProp,
      confirmEmailModal: this.value,
      participant: new Participant(),
      showVerifyOtpModal: false,
      phoneVerified: false,
      otp: ["", "", "", "", "", ""],
      pid: this.participantId,
      mobileOtp: "",
      cantContinue: false
    };
  },
  watch: {
    showLoaderProp(val) {
      this.showLoader = val;
    },
    value(val) {
      this.confirmEmailModal = val;
    },
    participantId(val) {
      this.pid = val;
    }
  },
  computed: {
    ...mapGetters(["participantRegistration", "token", "pwebCognitoAuthentication"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    participantFullName() {
      const { firstName, lastName } = this.participantRegistration.participantMeta;
      const fullName = firstName + " " + lastName;
      return fullName;
    },
    isEmailVerification() {
      return this.participantRegistration.verificationMethod == "email";
    },
    isPhoneVerification() {
      return this.participantRegistration.verificationMethod == "phone";
    },
    verifyIdentityPageTitle() {
      return this.isEmailVerification ? this.widget.translate("pw_email_confirmation", "Email Confirmation") : this.widget.translate("mobile_confirm", "Confirm Phone");
    },
    verifyTextSendToText() {
      return this.isEmailVerification ? this.widget.translate("verify_email", "Verification email was sent to") : this.widget.translate("label_verification_sent_to", "Verification text was sent to");
    },
    resendConfirmCodeDescription() {
      return this.isEmailVerification ? this.widget.translate("verify_email_message", "If you have not received the verification email within a fewminutes, please check your Spam or Junk folder.") : this.widget.translate("verify_verification_message", "If you have not received the verification text within a few minutes, please try resending your verification text.");
    },
    resendVerificationBtnText() {
      return this.isEmailVerification ? this.widget.translate("label_resend_email", "Resend verification email") : this.widget.translate("label_resend_sms", "Resend verification SMS text");
    },
    participantIdentity() {
      return this.participant.getParticipantIdentity(true);
    }
  },
  methods: {
    ...mapActions(["participantLogout", "participantLogin", "awsCognitoParticipantLogin"]),
    onResendVerification() {
      if (this.isEmailVerification) {
        this.onResendEmailVerification();
      } else {
        this.onResendVerificationCode();
      }
    },
    onResendEmailVerification() {
      const verificationPayload = {
        studyId: this.portal.getStudy(),
        email: this.participantRegistration.participantMeta.email,
        language: this.portal.getLanguage()
      };
      if (!this.portal.isOpenEnrollmentStudy) {
        this.verificationPayload.email = this.participantRegistration.verificationPhone;
        this.verificationPayload.verificationMethod = this.participantRegistration.verificationMethod;
      }
      this.$api
        .verifyParticipantEmail(verificationPayload)
        .then(res => {
          const message = this.widget.translate(res.body.message_key, res.body.message);
          if (message) {
            this.$toastr.success(message);
          }
        })
        .catch(err => {
          const message = this.widget.translate(err.message, "Error!");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    checkIfVerified() {
      if (this.isEmailVerification) {
        this.submitEmail();
      } else {
        this.showVerifyOtpModal = true;
      }
    },
    submitEmail() {
      const loginPayload = {
        country: this.portal.getCountry(),
        deviceId: uuidv4(),
        email: this.pwebCognitoAuthentication ? this.participantRegistration && this.participantRegistration.cognitoUsername : this.participantRegistration.participantMeta.email,
        isUserAlreadyLoggedIn: false,
        language: this.portal.getLanguage(),
        participantLocalTime: this.date.toISOString(),
        participantLocalTimeOffset: this.date.getTimezoneOffset(),
        password: this.participantRegistration.participantMeta.password,
        studyId: this.portal.getStudy(),
        studyVersionId: this.portal.getVersion(),
        updatePartLang: false,
        deviceType: "web"
      };
      const VerifyEmailPayload = {
        emailVerified: false,
        otp: "",
        password: "",
        username: this.participantRegistration.cognitoUsername
      };
      const self = this;
      const showSwal = () => {
        if (this.pwebCognitoAuthentication) {
          this.$api.verifyCognitoUserEmail(VerifyEmailPayload).then(res => {
            const result = res.body;
            if (result.message) {
              this.cognitoLogin(loginPayload);
            } else {
              swal({
                title: this.widget.translate("email_not_verified", "Please check your email to verify your account before continuing."),
                type: "warning",
                showCancelButton: false,
                confirmButtonColor: this.globalElements.colorPrimary ? this.globalElements.colorPrimary :"var(--primary)!important",
                cancelButtonText: this.widget.translate("OK_BUTTON_TITLE", "Ok")
              }).then(() => {});
            }
          });
        } else {
          this.verifyEmail(loginPayload);
        }
      };
     showSwal();
    },
    verifyEmail(loginPayload) {
      const accesstoken = this.portal.getLocalStorage("participantRegisteredAccessToken");
      this.$api.getParticipantEmailStatus(this.pid || this.participant.getParticipantID(accesstoken)).then(res => {
        if (res.body.status === "VERIFIED") {
          this.legacyLogin(loginPayload);
        } else {
          swal({
            title: this.widget.translate("email_not_verified", "Please check your email to verify your account before continuing."),
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: this.globalElements.colorPrimary ? this.globalElements.colorPrimary :"var(--primary)!important",
            cancelButtonText: this.widget.translate("OK_BUTTON_TITLE", "Ok")
          }).then(() => {});
        }
      });
    },
    legacyLogin(loginPayload) {
      this.participantLogin(loginPayload)
        .then(res => {
          localStorage.setItem("checkSchedule", true);
          if (res) {
            this.showLoader = false;
            this.confirmEmail = false;
          }
        })
        .catch(() => {
          this.cantContinue = false;
        });
    },
    cognitoLogin(loginPayload) {
      this.awsCognitoParticipantLogin(loginPayload)
        .then(res => {
          if (res) {
            this.showLoader = false;
            this.confirmEmail = false;
          }
        })
        .catch(err => {
          this.cantContinue = false;
          const message = this.widget.translate(err.message, "Unable to login, please try after some time.");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    onResendVerificationCode() {
      this.$api
        .resendPhoneOtp(this.participantId)
        .then(res => {
          this.$root.$emit("onOtpResent");
          if (res.body.message != null && res.body.message_key != null) {
            this.$toastr.success(this.widget.translate(res.body.message_key, res.body.message));
          }
        })
        .catch(err => {
          this.$toastr.error(err);
        });
    },
    verifyOtp(otp) {
      this.mobileOtp = otp;
      this.$api
        .verifyPhoneOtp(this.participantId, otp)
        .then(() => {
          this.phoneVerified = true;
        })
        .catch(err => {
          if (err.body.message == "label_verification_code_invalid") {
            this.$toastr.error(this.widget.translate(err.body.message, "The verification code you entered is not correct. Please try again."));
          } else {
            this.$toastr.error(err.body.message);
          }
        });
    },
    continueToPweb() {
      this.cantContinue = true;
      const loginPayload = {
        mobile: this.participantRegistration.mobile,
        mobileCountryCode: "+" + this.phoneObject.country.dialCode,
        otp: this.mobileOtp,
        country: this.portal.getCountry(),
        deviceId: uuidv4(),
        isUserAlreadyLoggedIn: true,
        language: this.portal.getLanguage(),
        participantLocalTime: this.date.toISOString(),
        participantLocalTimeOffset: this.date.getTimezoneOffset(),
        studyId: this.portal.getStudy(),
        studyVersionId: this.portal.getVersion(),
        updatePartLang: false
      };
      if (this.pwebCognitoAuthentication) {
        loginPayload["password"] = this.participantRegistration.password;
        loginPayload["email"] = this.participantRegistration.cognitoUsername;
        this.cognitoLogin(loginPayload);
      } else {
        this.legacyLogin(loginPayload);
      }
    }
  }
};
</script>
<style scoped>
div.partipant-registration-modal__container div.continue-btn-div {
  width: 100%;
  padding: 20px;
}
.email-text1 {
  font-family: RobotoRegular;
  font-size: 16px;
  line-height: 1.31;
  letter-spacing: -0.32px;
  color: #4c6473;
}
.email-text2 {
  margin: 48px 121px 13px 121px;
  font-family: RobotoRegular;
  font-size: 13px;
  line-height: 1.38;
  letter-spacing: -0.08px;
  color: #9b9b9b;
}
.email-id {
  font-family: Robotolight;
  font-size: 28px;
  font-weight: 300;
  color: #4a4a4a;
  padding: 0 48px;
  word-break: break-all;
}
.email-text {
  margin: 13px 20px 48px 20px;
  font-family: RobotoRegular;
  font-size: 13px;
  line-height: 1.38;
  letter-spacing: -0.08px;
  color: #9b9b9b;
}
div.phone-verified {
  padding: 50px;
}
div.phone-verified div.phone-verified-check img {
  display: block;
  margin: auto;
  width: 100px;
}
.verifyRegistrationPhone .text-center.forgot-pwd-btn {
  padding-top: 50px;
}
</style>
